import { Application } from '@hotwired/stimulus';
const application = Application.start();

// c
import NavigationController from '@sharedSrc/controllers/navigation_controller';
import AccordionController from '@sharedSrc/controllers/accordion_controller';
import CarouselController from '@sharedSrc/controllers/carousel_controller';
import DisrupterController from '@sharedSrc/controllers/disrupter_controller';
import RedirectSelectController from './redirect_select_controller';
import FilterListController from './filter_list_controller';
import SideMenuController from './side_menu_controller';
import SubNavSelect from './sub_nav_select_controller';
import TableauViz from './tableau_viz_controller';
import FuzzySearchFormController from './fuzzysearch_form_controller'
import SortingController from './sorting_controller'
import ActivationStatusController from './activation_status_controller'
import AutocompleteSortController from './autocomplete_sort_controller'
import TooltipController from './tooltip_controller';
import HrmChartController from './hrm_chart_controller';
import RekoHandoutController from './reko_handout_controller';
import EnterpriseChartController from './enterprise_chart_controller';
import ToggleFormController from "./toggle_form_controller";
import MultiSelect from './multi_select_controller';
import HoverController from './hover_controller';
import LoadingController from './loading_controller';
import { Modal } from 'tailwindcss-stimulus-components';
import XDashboardController from './x_dashboard_controller'; //dashboard data and vue init for main content in dashhboard show layout
import Drawer from './drawer_controller'; //drawer for asides in dashhboard show layout
import Zoom from './zoom_controller'; //zoom main content in dashhboard show layout
import BasecheckController from './basecheck_controller';
import NotificationController from './notification_controller';
import BackTopController from './backtop_controller';
import AnnouncementsController from '../../shared/announcements_controller';
import TourController from './tour_controller';
import RekoWordCloudController from "./reko_word_cloud_controller";
import ModalController from '@sharedSrc/controllers/modal_controller';
import TextareaAutoExpandController from './textarea_auto_expand_controller';
import XLayerController from './x_layer_controller';
import NotificationsController from './notifications_controller';
import PermissionMatrixController from './permission_matrix_controller';
import PermissionMatrixFormController from './permission_matrix_form_controller';
import DiscoveryFormController from './discovery_form_controller';
import DiscoveryProgressOverlayController from './discovery_progress_overlay_controller';

// externals
import { Autocomplete } from 'stimulus-autocomplete';

// c
application.register('accordion', AccordionController);
application.register("redirect-select", RedirectSelectController);
application.register("filter-list", FilterListController);
application.register("side-menu", SideMenuController);
application.register('sub-nav-select', SubNavSelect);
application.register('navigation', NavigationController);
application.register('tableau-viz', TableauViz);
application.register('fuzzysearch-form', FuzzySearchFormController);
application.register('sorting', SortingController);
application.register('activation-status', ActivationStatusController)
application.register('autocomplete-sort', AutocompleteSortController);
application.register('tooltip', TooltipController);
application.register("hrm-chart", HrmChartController)
application.register("reko-handout", RekoHandoutController)
application.register("enterprise-chart", EnterpriseChartController)
application.register('toggle-form', ToggleFormController);
application.register('accordion', AccordionController);
application.register('disrupter', DisrupterController);
application.register('carousel', CarouselController);
application.register('hover', HoverController);
application.register('modal', Modal);
application.register('x-dashboard', XDashboardController); //dashboard data and vue init for main content in dashhboard show layout
application.register('basecheck', BasecheckController);
application.register('drawer', Drawer); //drawer for asides in dashhboard show layout
application.register('zoom', Zoom); //zoom main content in dashhboard show layout
application.register('loading', LoadingController);
application.register('notification', NotificationController);
application.register('backtop', BackTopController);
application.register('announcements', AnnouncementsController);
application.register('tour', TourController);
application.register('reko-word-cloud', RekoWordCloudController);
application.register('modal', ModalController);
application.register('textarea-auto-expand', TextareaAutoExpandController);
application.register('x-layer', XLayerController);
application.register('notifications', NotificationsController);
application.register('permission-matrix', PermissionMatrixController);
application.register('permission-matrix-form', PermissionMatrixFormController);
application.register('discovery-form', DiscoveryFormController);
application.register('discovery-progress-overlay', DiscoveryProgressOverlayController);
// externals
application.register('multiselect', MultiSelect);
application.register('autocomplete', Autocomplete);
